import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.333 22.94c-.848 0-1.604-.5-1.96-1.251-1.783-3.772-3.568-6.116-6.2-7.75H5V2.69h1.779l6.5-1.5h7.82a1.375 1.375 0 0 1 0 2.75h-.5a.625.625 0 1 0 0 1.25h1.5a1.375 1.375 0 0 1 0 2.75h-.5a.625.625 0 1 0 0 1.25h1a1.375 1.375 0 0 1 0 2.75h-1a.625.625 0 0 0 0 1.25h1a1.375 1.375 0 0 1 0 2.75h-7.834c.618 1.618 1.2 3.36 1.497 4.743.276 1.28-.77 2.258-1.93 2.258ZM3.5 14.5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h1.5a1 1 0 0 1 1 1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ThumbsDown = { render };
export {
  ThumbsDown as default,
  render
};
//# sourceMappingURL=ThumbsDown.svg.js.map
